import { render } from "./MykwsEmailServiceIcon.vue?vue&type=template&id=bae33eea"
import script from "./MykwsEmailServiceIcon.vue?vue&type=script&lang=js"
export * from "./MykwsEmailServiceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__